module.exports = __webpack_public_path__ + "static/media/powerpoint_48x1.4a87108e.svg";